<template>
  <LayoutTelas
    id="tela__lancamentos"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <BButton
      class="btnNovo"
      variant="primary"
      @click="novo">
      Novo atendimento
    </BButton>

    <div v-if="emAberto.length > 0">
      <label>Em aberto</label>
      <BTable
        :items="emAberto"
        :fields="camposTabela"
        @row-clicked="clicouItemTabela">
        <template
          :slot="'dataAbertura'"
          slot-scope="data">
          {{ data.value | formatDateTime }}
        </template>

        <template
          :slot="'total'"
          slot-scope="data">
          {{ data.value | currency }}
        </template>

      </BTable>
    </div>

    <div
      v-if="totais"
      class="container__totais">
      <BButton
        variant="outline-primary"
        v-b-toggle.lucros
        class="botao__totais">
        Meus lucros
      </BButton>
      <BCollapse
        id="lucros">
        <div class="container__lucros">
          <div class="lucros__item">
            <p class="lucros__item__titulo">Hoje</p>
            <p class="lucros__item__valor">{{ totais.dia | currency }}</p>
          </div>
          <div class="lucros__item">
            <p class="lucros__item__titulo">Últimos 7 dias</p>
            <p class="lucros__item__valor">{{ totais.semana | currency }}</p>
          </div>
          <div class="lucros__item">
            <p class="lucros__item__titulo">Últimos 15 dias</p>
            <p class="lucros__item__valor">{{ totais.quinzena | currency }}</p>
          </div>
          <div class="lucros__item">
            <p class="lucros__item__titulo">Últimos 30 dias</p>
            <p class="lucros__item__valor">{{ totais.mes | currency }}</p>
          </div>
        </div>
      </BCollapse>
    </div>

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      main-icon="add"
      :start-opened="true"
      @atualizar="carrega"
      @mostrarLucros="mostrarLucros"
    />

  </LayoutTelas>
</template>

<script>
import fab from 'vue-fab'

import { BButton, BCollapse, BTable } from 'bootstrap-vue/es/components'
import LancamentoService from '@/modules/atendimento/services/lancamento.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'mostrarLucros',
      icon: 'money',
      tooltip: 'Meus rendimentos',
    },
    {
      name: 'atualizar',
      icon: 'sync',
      tooltip: 'Atualizar',
    },
  ],
}

export default {
  name: 'LancamentoServicos',
  components: {
    BButton,
    BCollapse,
    BTable,
    fab,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      funcionario: null,
      isLoading: false,
      dados: [],
      camposTabela: this.retornaCamposTabela(),
      atendimentos: [],
      floatButton: botaoFlutuante,
    }
  },
  computed: {
    emAberto: function () {
      if (this.atendimentos && this.atendimentos.emAberto) {
        return this.atendimentos.emAberto
      }
      return []
    },
    totais: function () {
      if (this.atendimentos && this.atendimentos.faturamentos) {
        return this.atendimentos.faturamentos
      }
      return null
    },
  },
  beforeMount() {
    this.carregarDadosUsuarioLogado()
    this.carrega()
  },
  methods: {
    async carrega(mostrarLucros = false) {
      this.mostrarLoader()
      try {
        const atendimentos = await LancamentoService
          .retornaAtendimentosUsuario(this.funcionario._id, mostrarLucros)

        this.atendimentos = atendimentos
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    novo() {
      this.$router.push({ name: 'rota-atendimento-servicos-novo' })
    },
    async carregarDadosUsuarioLogado() {
      this.funcionario = this.$store.getters['autenticacao/userObj'].usuario
    },
    retornaCamposTabela() {
      return {
        cliente: {
          label: 'Cliente',
        },
        dataAbertura: {
          label: 'Data',
        },
        total: {
          label: 'Total',
        },
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
    clicouItemTabela(item) {
      if (item) {
        this.$router.push({
          name: 'rota-atendimento-servicos-alteracao',
          params: { id: item._id },
        })
      }
    },
    mostrarLucros() {
      this.carrega(true)
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";
@import "@/scss/colors.scss";

#tela__lancamentos {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $small-size) {
    min-width: $extra-small-size;
  }
}

.container {
  &__lucros {
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }
}

.lucros__item {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__titulo {
    font-weight: 300;
  }

  &__valor {
    font-size: 1.5rem;
    font-weight: 500;
    color: $cor-verde;
  }
}

.btnNovo {
  margin-bottom: 0.5rem;
}

.container__totais {
  width: 100%;
}

.botao__totais {
  width: 100%;
}

</style>
